import { createSelector } from 'reselect';

const selectDiagnosticsDomain = () => (state) =>
  state.get('supportDiagnostics');

const makeSelectDiagnostics = () =>
  createSelector(selectDiagnosticsDomain(), (substate) => substate);

export { makeSelectDiagnostics };
